import { Box, Button, useTheme } from "@mui/material";
import {
    likeNewsAction as likeAction,
    dislikeNewsAction as dislikeAction,
} from "../../redux/slices/userSlice";
import { likeNews as like, dislikeNews as dislike } from "../../actions";
import { useDispatch, useSelector } from "react-redux";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import { useState, useEffect } from "react";
import CountLikeAndDislike from "./CountLikeAndDislike";

const LikeAndDislike = ({ item = {}, sx = {} }) => {
    const [likes, setLikes] = useState(0);
    const [dislikes, setDislikes] = useState(0);

    const theme = useTheme();

    const news = useSelector((state) => state.news);

    const dispatch = useDispatch();

    useEffect(() => {
        if (item.likes) setLikes(parseInt(item.likes));
        if (item.dislikes) setDislikes(parseInt(item.dislikes));
    }, [item]);

    const handleLike = () => {
        like(item.id, news[item.id] == "L")
            .then(() => {
                if (news[item.id] == "L") setLikes(likes - 1);
                if (!news[item.id]) setLikes(likes + 1);
                if (news[item.id] == "D") {
                    setLikes(likes + 1);
                    setDislikes(dislikes - 1);
                    dislike(item.id, true)
                        .then(() => {})
                        .catch((err) => console.log(err));
                }
            })
            .catch((err) => console.log(err));
        dispatch(likeAction({ id: item.id }));
    };

    const handleDisLike = () => {
        dislike(item.id, news[item.id] == "D")
            .then(() => {
                if (news[item.id] == "D") setDislikes(dislikes - 1);
                if (!news[item.id]) setDislikes(dislikes + 1);
                if (news[item.id] == "L") {
                    setDislikes(dislikes + 1);
                    setLikes(likes - 1);
                    like(item.id, true)
                        .then(() => {})
                        .catch((err) => console.log(err));
                }
            })
            .catch((err) => console.log(err));
        dispatch(dislikeAction({ id: item.id }));
    };

    return (
        <Box
            sx={{
                ...sx,
                display: "flex",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                }}
            >
                <Button
                    onClick={handleLike}
                    sx={{
                        display: "flex",
                        color: theme.palette.primary.main,
                        alignItems: "center",
                    }}
                >
                    {news[item.id] != "L" && (
                        <ThumbUpOffAltIcon
                            sx={{
                                width: "18px",
                                height: "18px",
                                marginRight: "5px",
                                cursor: "pointer",
                            }}
                        />
                    )}
                    {news[item.id] == "L" && (
                        <ThumbUpAltIcon
                            sx={{
                                width: "18px",
                                height: "18px",
                                marginRight: "5px",
                                cursor: "pointer",
                            }}
                        />
                    )}
                    <CountLikeAndDislike count={likes} />
                </Button>
            </Box>

            <Box
                sx={{
                    display: "flex",
                }}
            >
                <Button
                    onClick={handleDisLike}
                    sx={{
                        display: "flex",
                        color: theme.palette.primary.main,
                        alignItems: "center",
                    }}
                >
                    {news[item.id] != "D" && (
                        <ThumbDownOffAltIcon
                            sx={{
                                width: "18px",
                                height: "18px",
                                marginRight: "5px",
                                cursor: "pointer",
                            }}
                        />
                    )}
                    {news[item.id] == "D" && (
                        <ThumbDownAltIcon
                            sx={{
                                width: "18px",
                                height: "18px",
                                marginRight: "5px",
                                cursor: "pointer",
                            }}
                        />
                    )}
                    <CountLikeAndDislike count={dislikes} />
                </Button>
            </Box>
        </Box>
    );
};

export default LikeAndDislike;
